import React from 'react';
import { Badge } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { AdminActionButton } from './AdminRowActions';
import ShipmentTrackingStatusBadge from './ShipmentTrackingStatusBadge';
import { copyTextToClipboard } from '../../helper/order_address_helper';
import {
  formatAwbShort,
  formatEtaDate,
  formatTrackingTimestampIst,
  getExpectedDeliveryDate,
  getLastShipmentUpdateTime,
  getOrderAwb,
  getOrderCourierName,
  getShipmentLastLocation,
  getShipmentListWarnings,
  isShipmentNotStarted,
} from '../../helper/shipment_tracking_helper';

async function copyAwb(awb) {
  try {
    await copyTextToClipboard(awb);
    toast.success('AWB copied');
  } catch {
    toast.error('Could not copy AWB');
  }
}

export default function OrderShipmentListCell({ order }) {
  if (!order || isShipmentNotStarted(order)) {
    return <span className="text-muted small">—</span>;
  }

  const courier = getOrderCourierName(order);
  const awb = getOrderAwb(order);
  const awbShort = formatAwbShort(awb);
  const lastUpdate = getLastShipmentUpdateTime(order);
  const eta = formatEtaDate(getExpectedDeliveryDate(order));
  const location = getShipmentLastLocation(order);
  const warnings = getShipmentListWarnings(order);

  return (
    <div className="order-shipment-list-cell">
      <div className="d-flex flex-wrap align-items-center gap-1 mb-1">
        <ShipmentTrackingStatusBadge order={order} className="order-shipment-list-cell__badge" />
        {warnings.map((w) => (
          <Badge
            key={w.code}
            bg={w.tone || (w.code === 'stuck' ? 'warning' : 'danger')}
            text={w.code === 'stuck' ? 'dark' : undefined}
            className="order-shipment-list-cell__warn"
          >
            {w.code === 'exception' ? (
              <i className="ri-error-warning-line me-1" aria-hidden="true" />
            ) : null}
            {w.label}
          </Badge>
        ))}
      </div>
      <div className="order-shipment-list-cell__courier text-truncate" title={courier}>
        {courier}
      </div>
      {location ? (
        <div
          className="order-shipment-list-cell__location text-truncate text-muted"
          title={location}
        >
          <i className="ri-map-pin-line me-1" aria-hidden="true" />
          {location}
        </div>
      ) : null}
      {awb ? (
        <div className="d-flex align-items-center gap-1 order-shipment-list-cell__awb-row">
          <code className="order-shipment-list-cell__awb" title={awb}>
            {awbShort}
          </code>
          <AdminActionButton
            action="copy"
            label="Copy AWB"
            aria-label="Copy AWB"
            onClick={() => copyAwb(awb)}
          />
        </div>
      ) : null}
      <div className="order-shipment-list-cell__meta text-muted">
        {lastUpdate ? formatTrackingTimestampIst(lastUpdate) : '—'}
      </div>
      {eta ? (
        <div className="order-shipment-list-cell__eta text-muted">
          ETA {eta}
        </div>
      ) : null}
    </div>
  );
}
